import { render, staticRenderFns } from "./WSurveysSearch.vue?vue&type=template&id=2081f13a&"
import script from "./WSurveysSearch.vue?vue&type=script&lang=ts&"
export * from "./WSurveysSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports